import { render, staticRenderFns } from "./ChooseSceneType.vue?vue&type=template&id=b3b14f60&scoped=true&"
import script from "./ChooseSceneType.vue?vue&type=script&lang=js&"
export * from "./ChooseSceneType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b14f60",
  null
  
)

export default component.exports